module.exports = require('./helpers/bundle-url').getBundleURL('5KjyH') + "logo-dark.eefe0b7f.svg";